
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from "react-router-dom";

import {
    IonModal,
    IonGrid,
    IonFooter,
    IonRow,
    IonCol,
    IonContent,
    IonHeader, IonPage, IonTitle, IonToolbar,
    IonApp,
    IonIcon,
    IonLabel,
    IonRouterOutlet,
    IonTabBar,
    IonTabButton,
    IonTabs,
    setupIonicReact,
    IonButton,
    IonRouterContext,
    IonRouteProps,
    IonLoading,
    IonToast,
    IonCard,
    IonFabButton,
    IonInfiniteScroll,
    IonSegment,
    IonSegmentButton,
    IonList,
    IonItem,
    IonText,
    IonFab,
    IonSearchbar,
    IonTextarea,
    IonInfiniteScrollContent,
    IonCheckbox,
    withIonLifeCycle, IonRefresher, IonRefresherContent
} from '@ionic/react';

import { arrowUp, business, barcode, person, podium, closeOutline, search, add, ticketOutline, location, receiptOutline, personOutline, callOutline, logoWhatsapp, locationOutline, mapOutline } from 'ionicons/icons';
import { DebounceInput } from 'react-debounce-input';
import PosActions from '../../../actions/PosActions';
import ContactModal from './ContactModal';
import './Contact.css';
import { getContact, getPermissions, getShoppingCart, getTransactions, getLoginApp, getTransactionPayments } from '../../../utils/functions';
import Moment from 'react-moment';
import moment from 'moment';
import Select from 'react-select';

import {
    queryAllPermisions
} from "../../../data_base_local/dataservice";
import { baseurl } from '../../../constants/constants';
import { Capacitor } from '@capacitor/core';

interface IProps {
    get_: any;
    post_: any;
}

interface IState {
    day_visit: any;
    contacts: any;
    pageSize: any;
    pages: any;
    loadmore_data_pagination: any;
    current_count_data: any;
    total_rows: any;
    searchText: any;

    ModalNotSellShow: any;
    fieldsNotSell: any;
    data_login_ari_app: any;
    rutas: any;
    ruta_ids: any;
}
class Contacts extends React.Component<IProps, IState> {
    contentRef: React.RefObject<HTMLIonContentElement>;
    ContactModal: any;
    ionInfiniteScrollRefData: React.RefObject<HTMLIonInfiniteScrollElement>;
    ModalNotSell: React.RefObject<HTMLIonModalElement>;

    constructor(props: any) {
        super(props)
        this.ContactModal = React.createRef();
        this.contentRef = React.createRef<HTMLIonContentElement>();
        this.ionInfiniteScrollRefData = React.createRef<HTMLIonInfiniteScrollElement>();
        this.ModalNotSell = React.createRef<HTMLIonModalElement>();

        this.state = {
            loadmore_data_pagination: props.loadmore_data_pagination,
            current_count_data: props.current_count_data,
            day_visit: props.day_visit, contacts: props.contacts, pageSize: props.pageSize,
            pages: props.pages,
            total_rows: props.total_rows,
            searchText: props.searchText,

            ModalNotSellShow: props.ModalNotSellShow,
            fieldsNotSell: props.fieldsNotSell,
            data_login_ari_app: props.data_login_ari_app,
            rutas: [],
            ruta_ids: null
        }
    }

    ionViewWillEnter() {
        //console.log('ionViewWillEnter 1 Contacts');
        //this.componentDidMount();
    }
    ionViewDidEnter() {
        //console.log('ionViewDidEnter 2 Contacts');

    }
    ionViewWillLeave() {
        //console.log('ionViewWillLeave 3 Contacts');

    }
    ionViewDidLeave() {
        //console.log('ionViewDidLeave 4 Contacts');

    }

    async componentDidMount() {
        if (Capacitor.isNativePlatform()) {
            this.ValidatePermission();
        }

        let data_login_ari_app: any = !getLoginApp() ? [] : getLoginApp();

        this.setState({
            day_visit: 'all',
            pages: 0,
            pageSize: 10,
            total_rows: 0,
            searchText: '',
            current_count_data: 0,
            loadmore_data_pagination: true,
            ModalNotSellShow: false,
            data_login_ari_app: data_login_ari_app,
            fieldsNotSell: {
                customer_id: null,
                contact_type_radio: 0,
                note: '',
                day: 0
            },
            rutas: [],
            ruta_ids: null
        });
        setTimeout(this.getDataPaginInit.bind(this), 1000);
    }

    /*necesario para validar permisos*/
    async ValidatePermission() {

        let dataPermissions: any = await queryAllPermisions().then();
        let is_valid = true;
        if (dataPermissions && dataPermissions.values.length > 0) {
            dataPermissions.values.map((val: any, key: any) => {
                if (val.status !== 'active') {
                    is_valid = false;
                }
            });
        } else {
            is_valid = false;
        }

        if (!is_valid) {
            window.location.href = baseurl() + "/home";
        }
    };
    /* fin necesario para validar permisos*/

    UNSAFE_componentWillReceiveProps(nextProps: any) {

        this.setState({
            contacts: nextProps.data.data_pagin && nextProps.data.data_pagin ? nextProps.data.data_pagin : [],
            pages: nextProps.data.contacts && nextProps.data.contacts.pages ? nextProps.data.contacts.pages : 0,
            total_rows: nextProps.data.contacts && nextProps.data.contacts.total_rows ? nextProps.data.contacts.total_rows : 0,
            current_count_data: nextProps.data.data_pagin ? nextProps.data.data_pagin.length : 0,
            rutas: nextProps.data.data_default && nextProps.data.data_default.rutas ? nextProps.data.data_default.rutas : [],

        });

        if (nextProps.data.view_active == "dashboard_pos/contacts") {
            if (nextProps.data.refresh_list && !nextProps.data.concat_list) {
                this.buttomup();
                this.setState({
                    day_visit: 'all',
                    pages: 0,
                    pageSize: 10,
                });

                setTimeout(this.getDataPaginInit.bind(this), 1000);
            }
            if (this.ionInfiniteScrollRefData.current) {
                if (nextProps.data.concat_list) {
                    this.ionInfiniteScrollRefData.current.complete();
                }
            }
        }

    }

    getDataPaginInit() {
        if (this.state.total_rows != 0 && this.state.current_count_data == this.state.total_rows && this.state.pages != 0) {
            if (this.ionInfiniteScrollRefData.current) {
                this.ionInfiniteScrollRefData.current.complete();
            }
            return;
        }

        this.props.get_({
            user_id: this.state.data_login_ari_app.id,
            typeOption: 'getDayRuteFull',
            search: this.state.searchText,
            day_visit: this.state.day_visit,
            pageSize: this.state.pageSize,
            pages: this.state.pages,
            current_count_data: this.state.current_count_data,
            view_active: 'dashboard_pos/contacts',
            ruta_ids: this.state.ruta_ids
        }, "api/getDayRuteFull");
    }

    changeDay(day_visit: any) {
        this.setState({
            day_visit: day_visit,
            pages: 0,
            pageSize: 10,
            loadmore_data_pagination: true
        });
        setTimeout(this.getDataPaginInit.bind(this), 100);
    }

    setClientStore(contact: any) {
        window.localStorage.setItem('ari_app_contact', JSON.stringify(contact));
    }

    async sendWhat(e: any, row: any) {
        /*// Define the content you want to share
        const shareText = 'Check out this awesome content!';
        const shareUrl = '<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAHElEQVQI12P4//8/w38GIAXDIBKE0DHxgljNBAAO9TXL0Y4OHwAAAABJRU5ErkJggg==" alt="Red dot" />';
        // Create the WhatsApp share URL
        // Open WhatsApp with the share URL
        window.location.href = whatsappUrl;*/
        const whatsappUrl = `https://api.whatsapp.com/send?phone=${row.mobile}$text=`;
        /*await Share.share({
          title: '??',
          text: "Conpartiendo algo con:" + row.name,
          //url: API + getPathImg() + row.imagen,
          dialogTitle: 'Compartir',
        });*/

    }

    get_localization(contact: any) {
        navigator.geolocation.getCurrentPosition((position) => {
            contact['lat_lng'] = position.coords.latitude + "," + position.coords.longitude;
            this.onRegionChange(contact);
        }, (error) => console.log(5555));
    }

    onRegionChange(row: any) {
        this.props.post_({
            typeOption: 'saveDataContact',
            not_update_day_visit: true,
            action: 'update',
            contact: row,
            user_id: this.state.data_login_ari_app.id,
            view_active: 'dashboard_pos/contacts'
        }, "api/saveDataContact");
    }

    redirect_to_map(row: any) {
        //https://www.google.com/maps/search/?api=1&query=58.698017,-152.522067
        let destination = row.lat_lng;

        let label = encodeURI('My Label');
        window.open('https://www.google.com/maps/search/?api=1&query=' + destination);

    }

    render_contacts(row: any, key: any) {
        //https://api.whatsapp.com/send/?phone=50512345678&text=
        let data_permission = getPermissions();

        return (
            <div className='card_line' key={key}>
                <IonRow >
                    <IonCol col-12 size='12'>
                        <label className='text-sm font-medium text-g60'><IonIcon className='icon-vertical-aling' size='small' icon={person} /> {row.name}</label>
                        <br />
                        <label className='text-g50 font-medium text-xs line-hei-150'><IonIcon className='icon-vertical-aling' size='small' icon={barcode} /> #{row.contact_id} </label>
                        <br />
                        <label className='text-g50 font-medium text-xs line-hei-150'><IonIcon className='icon-vertical-aling' size='small' icon={business} /> {row.address_line_1} </label>
                        <br />
                        <label className='text-g50 font-medium text-xs line-hei-150'><IonIcon className='icon-vertical-aling' size='small' icon={location} /> {row.ruta_name} </label>
                    </IonCol>
                    <IonCol col-12 size='12' className='text-center'>
                        <IonButton size='default' onClick={() => this.setActionClientModalShow(row, key)}>
                            Acciones
                        </IonButton>
                    </IonCol>
                    <IonModal onWillDismiss={e => this.closemodalClientActions(row, key)} isOpen={row.modalOpen ?? false} trigger="open-modal" initialBreakpoint={0.50} breakpoints={[0, 0.50, 0.5, 0.75]}>
                        <IonHeader>
                            <IonToolbar>
                                <IonTitle>{row.name}</IonTitle>
                                <IonButton slot="end" style={{ textAling: "center", marginRight: '10px' }} onClick={(ev) => this.closemodalClientActions(row, key)}>
                                    <IonIcon icon={closeOutline}></IonIcon>
                                </IonButton>
                            </IonToolbar>
                        </IonHeader>
                        <IonContent className="ion-padding">
                            <IonRow>

                                <IonCol col-4 size='4' className='text-center'>
                                    <IonButton size='default' className='buttomwith100' onClick={() => { }}>
                                        <div>
                                            <IonIcon
                                                color="#ffffff"
                                                slot="icon-only"
                                                icon={callOutline}
                                                size="small"
                                            />
                                            <br />
                                            <label className='fontzise'>LLamar</label>
                                        </div>
                                    </IonButton>
                                </IonCol>
                                <IonCol col-4 size='4' className='text-center'>

                                    <IonButton size='default' className='buttomwith100' href={`https://api.whatsapp.com/send?phone=${row.mobile}$text=`}>
                                        <div>
                                            <IonIcon
                                                color="#ffffff"
                                                slot="icon-only"
                                                icon={logoWhatsapp}
                                                size="small"
                                            />
                                            <br />
                                            <label className='fontzise'>Mensaje</label>
                                        </div>
                                    </IonButton>
                                </IonCol>
                                {
                                    data_permission && data_permission.pin_contact_app ?
                                        <IonCol col-4 size='4' className='text-center'>

                                            <IonButton size='default' className='buttomwith100' onClick={() => this.get_localization(row)}>
                                                <div>
                                                    <IonIcon
                                                        color="#ffffff"
                                                        slot="icon-only"
                                                        icon={locationOutline}
                                                        size="small"
                                                    />
                                                    <br />
                                                    <label className='fontzise'>PIN EN MAPA</label>
                                                </div>
                                            </IonButton>
                                        </IonCol> : null
                                }

                                {
                                    row.lat_lng ?
                                        <IonCol col-4 size='4' className='text-center'>
                                            <IonButton size='default' className='buttomwith100' onClick={() => this.redirect_to_map(row)}>
                                                <div>
                                                    <IonIcon

                                                        color="#ffffff"
                                                        slot="icon-only"
                                                        icon={mapOutline}
                                                        size="small"
                                                    />
                                                    <br />
                                                    <label className='fontzise'>VER EN MAPA</label>
                                                </div>
                                            </IonButton>
                                        </IonCol> : null
                                }
                                <IonCol col-4 size='4' className='text-center'>

                                    <IonButton size='default' className='buttomwith100' onClick={() => this.ContactModal.current.handleShow(row)}>
                                        <div>
                                            <IonIcon
                                                color="#ffffff"
                                                slot="icon-only"
                                                icon={personOutline}
                                                size="small"
                                            />
                                            <br />
                                            <label className='fontzise'>Editar</label>
                                        </div>
                                    </IonButton>

                                </IonCol>
                                <IonCol col-4 size='4' className='text-center'>

                                    <IonButton size="small" className='buttomwith100' onClick={() => this.openModalNotSell(row)}>
                                        <div>
                                            <IonIcon
                                                color="#ffffff"
                                                slot="icon-only"
                                                icon={podium}
                                                size="small"
                                            />
                                            <br />
                                            <label className='fontzise'>No Venta</label>
                                        </div>
                                    </IonButton>

                                </IonCol>
                                <IonCol col-4 size='4' className='text-center'>

                                    <IonButton size='default' className='buttomwith100' onClick={() => this.setClientStore(row)}>

                                        <Link style={{ textDecoration: 'none', color: "#ffffff" }} to={"/dashboard_pos/products"}>
                                            <div>
                                                <IonIcon
                                                    color="#ffffff"
                                                    slot="icon-only"
                                                    icon={receiptOutline}
                                                    size="small"
                                                />
                                                <br />
                                                <label className='fontzise'>Facturar</label>
                                            </div>

                                        </Link>
                                    </IonButton>
                                </IonCol>
                            </IonRow>
                        </IonContent>
                    </IonModal>
                </IonRow>
            </div>

        );
    }


    closemodalClientActions(row: any, index: any) {
        let contacts = this.state.contacts;

        const newArr = contacts.map((item: any, i: any) => {
            if ((index) == i) {
                return {
                    ...item,
                    'modalOpen': false
                };
            } else {
                return item;
            }
        });

        this.setState({
            contacts: newArr
        });
    }
    setActionClientModalShow(row: any, index: any) {
        let contacts = this.state.contacts;

        const newArr = contacts.map((item: any, i: any) => {
            if ((index) == i) {
                return {
                    ...item,
                    'modalOpen': true
                };
            } else {
                return item;
            }
        });

        this.setState({
            contacts: newArr
        });
    }


    handleChangeNotSell(event: any) {
        let fieldsNotSell = this.state.fieldsNotSell;
        fieldsNotSell[event.target.name] = event.target.value;
        this.setState({
            fieldsNotSell: fieldsNotSell
        });
    }
    openModalNotSell(row: any) {
        let fieldsNotSell = this.state.fieldsNotSell;
        fieldsNotSell['customer_id'] = row.id;
        this.setState({
            ModalNotSellShow: true,
            fieldsNotSell: fieldsNotSell
        });
    }
    dismissModalNotSell() {
        this.setState({
            ModalNotSellShow: false,
            fieldsNotSell: {
                customer_id: null,
                contact_type_radio: 0,
                note: '',
                day: 0
            }
        });
    }

    sendNotSell() {

        let fieldsNotSell = this.state.fieldsNotSell;

        this.props.post_({
            transaction_date: moment(new Date(), "YYYY-MM-DD hh:mm").format("YYYY-MM-DD") + " " + moment(new Date(), "YYYY-MM-DD hh:mm").format("hh:mm:ss"),
            typeOption: 'not_sell',
            action: 'create',
            fieldsNotSell: fieldsNotSell,
            view_active: 'dashboard_pos/contacts',
            user_id: this.state.data_login_ari_app.id
        }, "api/not_sell");
        this.dismissModalNotSell();

    }

    setSearchText(e: any) {
        const value = e.target.value;
        this.setState({
            searchText: value.toLowerCase(),
            pages: 0,
            pageSize: 10,
            loadmore_data_pagination: true
        });
        setTimeout(this.getDataPaginInit.bind(this), 100);
    }

    buttomup() {
        if (this.contentRef.current) {
            this.contentRef.current.scrollToTop();
        }
    }

    handleRefresh(event: any) {
        this.setState({
            pages: 0,
            pageSize: 10,
        });
        setTimeout(() => {
            event.detail.complete();
        }, 2000);
        setTimeout(this.getDataPaginInit.bind(this), 1000);
    }

    handleChangeDefault(event: any) {
        console.log(event);
        this.setState({
            ...this.state,
            [event.target.name]: event.target.value,
            pages: 0,
            pageSize: 10
        });

        setTimeout(this.getDataPaginInit.bind(this), 100);

    }
    render() {
        const { day_visit, contacts, searchText, ModalNotSellShow, fieldsNotSell, rutas } = this.state;
        let data_render_contacts = [];
        if (contacts && contacts.length > 0) {
            data_render_contacts = [];
            data_render_contacts = contacts.map((val: any, key: any) =>
                this.render_contacts(val, key)
            );
        };
        return (
            <IonPage>
                <ContactModal ref={this.ContactModal} />
                <IonHeader>
                    <IonToolbar color="primary">
                        <IonTitle>Clientes por Día</IonTitle>
                    </IonToolbar>
                </IonHeader>
                <IonContent fullscreen scrollEvents={true} ref={this.contentRef}>
                    <IonRefresher slot="fixed" onIonRefresh={(e) => this.handleRefresh(e)}>
                        <IonRefresherContent></IonRefresherContent>
                    </IonRefresher>
                    <IonRow>
                        <IonCol col-12 size='12' class='div_horizontal_buttom_segment_pos_contact'>
                            <IonSegment value={day_visit} scrollable={true}>
                                <IonSegmentButton
                                    value={'all'}
                                    onClick={() =>
                                        this.changeDay('all')
                                    }
                                >
                                    <IonLabel>Todos</IonLabel>
                                </IonSegmentButton>

                                <IonSegmentButton
                                    value={1}
                                    onClick={() =>
                                        this.changeDay(1)
                                    }
                                >
                                    <IonLabel>Lunes</IonLabel>
                                </IonSegmentButton>

                                <IonSegmentButton
                                    value={2}
                                    onClick={() =>
                                        this.changeDay(2)
                                    }
                                >
                                    <IonLabel>Martes</IonLabel>
                                </IonSegmentButton>
                                <IonSegmentButton
                                    value={3}
                                    onClick={() =>
                                        this.changeDay(3)
                                    }
                                >
                                    <IonLabel>Miercoles</IonLabel>
                                </IonSegmentButton>
                                <IonSegmentButton
                                    value={4}
                                    onClick={() =>
                                        this.changeDay(4)
                                    }
                                >
                                    <IonLabel>Jueves</IonLabel>
                                </IonSegmentButton>
                                <IonSegmentButton
                                    value={5}
                                    onClick={() =>
                                        this.changeDay(5)
                                    }
                                >
                                    <IonLabel>Viernes</IonLabel>
                                </IonSegmentButton>
                                <IonSegmentButton
                                    value={6}
                                    onClick={() =>
                                        this.changeDay(6)
                                    }
                                >
                                    <IonLabel>Sabado</IonLabel>
                                </IonSegmentButton>
                                <IonSegmentButton
                                    value={0}
                                    onClick={() =>
                                        this.changeDay(0)
                                    }
                                >
                                    <IonLabel>Domingo</IonLabel>
                                </IonSegmentButton>


                            </IonSegment>
                        </IonCol>
                        <IonCol col-12 size='12' style={{ textAlign: "center" }}>
                            <div style={{ display: "none" }}>
                                <IonSearchbar onIonChange={e => this.setSearchText(e)} value={searchText}></IonSearchbar>
                            </div>

                        </IonCol>
                        <IonCol col-12 size='12'>
                            {
                                rutas && rutas && rutas.length > 0 ?
                                    <Select
                                        onChange={(e: any) => this.handleChangeDefault({ target: { name: 'ruta_ids', value: e } })}
                                        placeholder="Rutas"
                                        name='ruta_ids'
                                        menuPortalTarget={document.querySelector('body')}
                                        isSearchable={false}
                                        isMulti={true}
                                        options={
                                            rutas.map((option: any) => (
                                                { label: option.name, value: option.id }
                                            ))
                                        }
                                        styles={{
                                            menu: provided => ({ ...provided, zIndex: 9999, color: 'black' }),
                                        }}

                                    /> : null
                            }
                        </IonCol>
                        <IonCol col-12 size='12' class='divflex'>
                            <IonIcon icon={search} className='iconseach'></IonIcon>

                            <DebounceInput
                                className='btn_search'
                                placeholder={'Buscar cliente por Nombre/Código'}
                                minLength={2}
                                debounceTimeout={2000}
                                value={searchText}
                                onChange={e => this.setSearchText(e)} />
                        </IonCol>
                        <IonCol col-12>
                            <IonList>
                                {data_render_contacts}
                            </IonList>
                        </IonCol>
                    </IonRow>
                    <IonFab slot="fixed" horizontal="end" vertical="bottom">
                        <IonFabButton onClick={() => this.ContactModal.current.handleShow(null)}>
                            <IonIcon icon={add}></IonIcon>
                        </IonFabButton>
                    </IonFab>
                    <IonInfiniteScroll threshold="50px" ref={this.ionInfiniteScrollRefData}
                        onIonInfinite={(event) => {
                            this.getDataPaginInit();
                        }}
                    >
                        <IonInfiniteScrollContent loadingText="Cargando mas datos..." loadingSpinner="bubbles"></IonInfiniteScrollContent>
                    </IonInfiniteScroll>

                    <IonModal onDidDismiss={this.dismissModalNotSell.bind(this)} isOpen={ModalNotSellShow} ref={this.ModalNotSell} trigger="open-modal" initialBreakpoint={0.60} breakpoints={[0, 0.60, 0.5, 0.75]}>
                        <IonContent className="ion-padding">
                            <IonHeader>
                                <IonToolbar>
                                    <IonTitle>No Venta</IonTitle>
                                    <IonButton slot="end" style={{ textAling: "center", marginRight: '10px' }} onClick={this.dismissModalNotSell.bind(this)}>
                                        <IonIcon icon={closeOutline}></IonIcon>
                                    </IonButton>
                                </IonToolbar>
                            </IonHeader>

                            <IonRow>
                                <IonCol col-6 size='6'>
                                    <IonCheckbox onIonChange={e => this.handleChangeNotSell({ target: { name: 'contact_type_radio', value: 1 } })} checked={fieldsNotSell && fieldsNotSell.contact_type_radio && fieldsNotSell.contact_type_radio == 1 ? true : false} labelPlacement="stacked" alignment="start">
                                        Cliente no se Encuentra
                                    </IonCheckbox>
                                </IonCol>
                                <IonCol col-6 size='6'>
                                    <IonCheckbox onIonChange={e => this.handleChangeNotSell({ target: { name: 'contact_type_radio', value: 2 } })} checked={fieldsNotSell && fieldsNotSell.contact_type_radio && fieldsNotSell.contact_type_radio == 2 ? true : false} labelPlacement="stacked" alignment="start">
                                        Negocio Cerrado
                                    </IonCheckbox>
                                </IonCol>
                                <IonCol col-6 size='6'>
                                    <IonCheckbox onIonChange={e => this.handleChangeNotSell({ target: { name: 'contact_type_radio', value: 3 } })} checked={fieldsNotSell && fieldsNotSell.contact_type_radio && fieldsNotSell.contact_type_radio == 3 ? true : false} labelPlacement="stacked" alignment="start">
                                        Cliente con Inventario
                                    </IonCheckbox>
                                </IonCol>
                                <IonCol col-6 size='6'>
                                    <IonCheckbox onIonChange={e => this.handleChangeNotSell({ target: { name: 'contact_type_radio', value: 4 } })} checked={fieldsNotSell && fieldsNotSell.contact_type_radio && fieldsNotSell.contact_type_radio == 4 ? true : false} labelPlacement="stacked" alignment="start">
                                        Cliente sin Recursos
                                    </IonCheckbox>
                                </IonCol>
                                <IonCol col-6 size='6'>
                                    <IonCheckbox onIonChange={e => this.handleChangeNotSell({ target: { name: 'contact_type_radio', value: 5 } })} checked={fieldsNotSell && fieldsNotSell.contact_type_radio && fieldsNotSell.contact_type_radio == 5 ? true : false} labelPlacement="stacked" alignment="start">
                                        Cliente Satisfecho
                                    </IonCheckbox>
                                </IonCol>
                                <IonCol col-6 size='6'>
                                    <IonCheckbox onIonChange={e => this.handleChangeNotSell({ target: { name: 'contact_type_radio', value: 6 } })} checked={fieldsNotSell && fieldsNotSell.contact_type_radio && fieldsNotSell.contact_type_radio == 6 ? true : false} labelPlacement="stacked" alignment="start">
                                        Cliente no Desea Comprar
                                    </IonCheckbox>
                                </IonCol>
                                <IonCol col-6 size='6'>
                                    <IonCheckbox onIonChange={e => this.handleChangeNotSell({ target: { name: 'contact_type_radio', value: 7 } })} checked={fieldsNotSell && fieldsNotSell.contact_type_radio && fieldsNotSell.contact_type_radio == 7 ? true : false} labelPlacement="stacked" alignment="start">
                                        Cobro/Abono
                                    </IonCheckbox>
                                </IonCol>
                                <IonCol col-12 size='12'>
                                    <IonTextarea onIonChange={e => this.handleChangeNotSell({ target: { name: 'note', value: e.target.value } })} value={fieldsNotSell && fieldsNotSell.note && fieldsNotSell.note} label="Nota de no Venta" labelPlacement="floating" placeholder="..."></IonTextarea>
                                </IonCol>
                                <IonCol col-12 size='12'>
                                    <IonButton onClick={this.sendNotSell.bind(this)} expand="block" className="ion-no-margin">Enviar no Venta</IonButton>
                                </IonCol>
                            </IonRow>

                        </IonContent>
                    </IonModal>
                    <IonFab style={{ marginBottom: "70px" }} slot="fixed" vertical="bottom" horizontal="end">
                        <IonFabButton>
                            <IonFabButton onClick={e => this.buttomup()}><IonIcon icon={arrowUp}></IonIcon></IonFabButton>
                        </IonFabButton>
                    </IonFab>
                </IonContent>
            </IonPage>
        );
    };
}

const mapStateToProps = (state: any) => {
    return {
        data: state.data,
        _get: PropTypes.func.isRequired,
        post_: PropTypes.func.isRequired,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        get_: (fields: any, controller: string) => dispatch(PosActions.get_(fields, controller)),
        post_: (data: any, controller: string) => dispatch(PosActions.post_(data, controller)),
    }
};

export default withIonLifeCycle(connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(Contacts));

